import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui class-name helper (DE-106). Standard clsx + tailwind-merge form:
 * clsx normalises the conditional inputs, tailwind-merge resolves conflicting
 * Tailwind utilities (last one wins) so component overrides compose cleanly.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
